import styled from 'styled-components';

export const Nav = styled.nav`
  background: #12131A;
  width: 100%;
  padding: 8px 0 4px;
  position: fixed;
  top: 0;
  z-index: 1000;
  border-bottom: 1px solid rgba(255,255,255,0.06);
`;
